import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay?: number) => {
    const savedCallback = useRef<() => void | undefined>();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            if (savedCallback && savedCallback.current) {
                savedCallback.current();
            }
        }

        if (delay !== undefined) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }

        return;
    }, [delay]);
};
